import React from 'react';
import { DeveloperExams } from './pages/DeveloperExams';
export function App() {
  return <DeveloperExams data-id="element-0" />;
}